import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8d2ee68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-login w-full h-screen" }
const _hoisted_2 = {
  key: 0,
  class: "w-full bg-[#FEF9E7] border-[#F1C21B] p-3 text-center text-sm text-textPrimary flex justify-center items-center gap-4 fixed top-0 z-50"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-left inter" }, "Para médicos, acesse o Minha Escala através do aplicativo", -1))
const _hoisted_4 = { class: "logo flex justify-center" }
const _hoisted_5 = { class: "flex justify-center" }
const _hoisted_6 = {
  key: 1,
  class: "card flex items-center flex-col rounded overflow-hidden shadow-lg gap-4"
}
const _hoisted_7 = { class: "flex flex-col gap-2 my-5 items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Criar nova senha de acesso", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "subtitle" }, " Preencha os campos abaixo para criar uma nova senha de acesso ao Minha Escala. ", -1))
const _hoisted_10 = { class: "flex flex-col gap-4 mt-5" }
const _hoisted_11 = { "data-testid": "recovery-new-password-input" }
const _hoisted_12 = { "data-testid": "recovery-repeat-password-input" }
const _hoisted_13 = { class: "flex flex-col gap-2 my-5 items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Senha alterada com sucesso!", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "subtitle" }, "Você já pode acessar o painel Minha Escala com a nova senha.", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle mt-4" }, "É médico(a)? Acesse pelo aplicativo:", -1))

import * as yup from 'yup'
import { ref, reactive, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useToast } from 'vue-toastification'
import Logo from '@/components/designSystem/Logo/index.vue'
import Steps from '@/components/designSystem/Steps/Index.vue'
import InvalidTokenPage from './components/invalidTokenPage.vue'
import Network from '@/Network'
import Input from '@/components/designSystem/Inputs/Input.vue'
import { passwordValidator } from '@/hooks/useYup'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import AppStoreBadges from '@/components/designSystem/AppStoreBadges/index.vue'
import { isMobileUserAgent, openAppStore } from '@/utils/appStoreLinks'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const toast = useToast()
const androidUrl = ref('')
const iosUrl = ref('')
const token = ref('')
const invalidToken = ref(false)
const isLoading = ref(false)
const route = useRoute()
const router = useRouter()
const isMobileDevice = ref(false)

// Estrutura reativa para armazenar valores e erros
const form = reactive({
  password: {
    value: '',
    error: null,
    validation: passwordValidator
  },
  repeatPassword: {
    value: '',
    error: null,
    validation: yup.string().required('Repetir senha é obrigatório')
  }
})

const validate = (_validate, field) => {
  _validate
    .validate(form[field].value)
    .then(() => {
      form[field].error = null
    })
    .catch((err) => {
      form[field].error = err.message
    })
}

const validateForm = (): boolean => {
  let isValid = true

  const schema = yup.object().shape({
    password: passwordValidator,
    repeatPassword: yup
      .string()
      .oneOf([form.password.value], 'As senhas não coincidem')
      .required('Repetir senha é obrigatório')
  })

  try {
    schema.validateSync(
      {
        password: form.password.value,
        repeatPassword: form.repeatPassword.value
      },
      { abortEarly: false }
    )
    form.password.error = null
    form.repeatPassword.error = null
  } catch (err: any) {
    err.inner.forEach((validationError: any) => {
      form[validationError.path].error = validationError.message
      isValid = false
    })
  }

  return isValid
}

const detectDevice = () => {
  isMobileDevice.value = isMobileUserAgent()
}

const openApp = () => {
  openAppStore(() =>
    toast.info('Abra a loja de aplicativos do seu celular e procure por "Minha Escala"')
  )
}

onMounted(() => {
  detectDevice()
})

onBeforeMount(async () => {
  isLoading.value = true
  try {
    if (!route.query['token']) {
      invalidToken.value = true
      return
    }
    token.value = String(route.query['token'])
    await Network.user.validateToken({ token: token.value })
  } catch {
    toast.error('Token inválido ou expirado')
    token.value = ''
    invalidToken.value = true
  } finally {
    isLoading.value = false
  }
})

const stepSelected = ref(0)

async function changeStep(step: number) {
  if (step === 0) {
    if (!validateForm()) return
    try {
      const res = await Network.user.changePassword({
        password: form.password.value,
        repeatPassword: form.repeatPassword.value,
        token: token.value
      })
      androidUrl.value = res.androidUrl
      iosUrl.value = res.iosUrl
      stepSelected.value = 1
    } catch (error) {
      toast.error(
        'Aconteceu um erro ao tentar alterar a senha, repita o processo de recuperação de senha novamente!'
      )
    }
  }
}

const goToLogin = () => {
  router.push({ name: 'signin' })
}

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isMobileDevice.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("button", {
            onClick: openApp,
            class: "bg-primary30 text-white font-bold py-1 px-4 rounded w-40",
            "data-testid": "recovery-open-app-button"
          }, " Abrir app "),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isMobileDevice.value = false)),
            class: "font-bold text-lg"
          }, "×")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(Logo, {
        width: "160px",
        logo: "full_text_white"
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      (isLoading.value)
        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
            key: 0,
            indeterminate: "",
            size: 128,
            width: 7,
            color: "primary"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (invalidToken.value)
              ? (_openBlock(), _createBlock(InvalidTokenPage, { key: 0 }))
              : (_openBlock(), _createBlock(Steps, {
                  key: 1,
                  onChangeStep: changeStep,
                  stepSelected: stepSelected.value,
                  stepsLength: 2,
                  title: "Redefinir senha",
                  btnText: "Alterar senha",
                  hiddenBtn: stepSelected.value === 1
                }, {
                  "step-0": _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _hoisted_9,
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(Input, {
                            modelValue: form.password.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.password.value) = $event)),
                            isError: !!form.password.error,
                            errorMessage: form.password.error,
                            width: "329px",
                            label: "Nova Senha",
                            type: "password",
                            onBlur: _cache[2] || (_cache[2] = () => validate(form.password.validation, 'password'))
                          }, null, 8, ["modelValue", "isError", "errorMessage"])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(Input, {
                            modelValue: form.repeatPassword.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.repeatPassword.value) = $event)),
                            isError: !!form.repeatPassword.error,
                            errorMessage: form.repeatPassword.error,
                            width: "329px",
                            label: "Repetir nova senha",
                            type: "password",
                            onBlur: _cache[4] || (_cache[4] = () => validate(form.repeatPassword.validation, 'repeatPassword'))
                          }, null, 8, ["modelValue", "isError", "errorMessage"])
                        ])
                      ])
                    ])
                  ]),
                  "step-1": _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _hoisted_15,
                      _createVNode(FilledButton, {
                        onClick: goToLogin,
                        text: "Fazer login",
                        width: "329px",
                        class: "mt-5 bg-primary30",
                        "data-testid": "recovery-login-button"
                      }),
                      _hoisted_16,
                      _createVNode(AppStoreBadges, {
                        class: "mt-5",
                        "android-url": androidUrl.value,
                        "ios-url": iosUrl.value
                      }, null, 8, ["android-url", "ios-url"])
                    ])
                  ]),
                  _: 1
                }, 8, ["stepSelected", "hiddenBtn"]))
          ]))
    ])
  ]))
}
}

})